import { types, actions } from './requests'
export const GETSESSIONDATALIST_TYPES = {
    ...types('GETSESSIONDATALIST'),
}
export const GETSESSIONDATALIST_ACTIONS = {
    ...actions('GETSESSIONDATALIST'),
}